import { Injectable } from '@angular/core';

import { defaultPaginationParameters } from '@shared/client/models/pagination.model';

@Injectable({
    providedIn: 'root',
})
export class PaginationParametersStoreService {
    private readonly localStoragePaginationKey = 'pagination';

    public getSavedTake(identifier: string): number {
        if (!localStorage.getItem(this.localStoragePaginationKey)) {
            localStorage.setItem(this.localStoragePaginationKey, '{}');
        }

        const localStoragePaginationParam = JSON.parse(localStorage.getItem(this.localStoragePaginationKey) as string);

        return localStoragePaginationParam[identifier] ?? defaultPaginationParameters.take;
    }

    public saveTake(identifier: string, take?: number): void {
        const localPaginationParams = JSON.parse(localStorage.getItem(this.localStoragePaginationKey) ?? '{}');

        localPaginationParams[identifier] = take;

        if (!localPaginationParams) {
            return;
        }

        localStorage.setItem(this.localStoragePaginationKey, JSON.stringify(localPaginationParams));
    }
}
